import axios from "axios";
const jsonConfig = require("../../Config.json");

const getQuestionBytestIdResponse = async (id) => {
  let allResponse = {};
  try {
    const getallresponse = await axios.get(
      jsonConfig.apiUrl + "QuestionByTestId/"+id,
     
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    allResponse = getallresponse;
    return Promise.resolve(allResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default getQuestionBytestIdResponse;
